module.exports = __webpack_public_path__ + "static/media/naveen.bc51285a.png";